import { Box, FormControlLabel, Switch } from "@mui/material";
import { useState, useEffect } from "react";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import { BomItemDetails } from "../../../../explorer/types/SpareParts/BomItemDetails";
import { MachineDocument } from "../../../../explorer/types/SpareParts/MachineDocument";
import AppCustomTabPanel from "../../../components/AppTabPanel/AppCustomTabPanel";
import PartList, {
  ColumnAlign,
  ColumnWidth,
} from "../../../components/PartsList/PartList";
import FileNameComponent, {
  FileDescrComponent,
} from "../../../components/PartsList/TableLayout/TableColumnComponents/FileNameComponent";
import useLanguages from "../../../../explorer/hooks/useLanguages";
import { Machine } from "../../../../explorer/types/SpareParts";
import { useReduxState } from "../../../../explorer/redux/hooks";
import { reduxStoreConfig } from "../../../configuration/reduxStoreConfig";

type MachineDocumentListProps = {
    rows: MachineDocument[] | BomItemDetails[];
    tabsValue: number;
    loading: boolean;
}

const MachineDocumentList = (props: MachineDocumentListProps) => {

  const [rows, setRows] = useState<MachineDocument[] | BomItemDetails[]>([]);
  const { t } = useTranslation();
  const lang = useLanguages().currentLanguage;
  const [docs, setDocs] = useState<MachineDocument[]>([]);
  const [valueSwitch, setValueSwitch] = useState<boolean>(true);
  const [currentMachine, setCurrentMachine] = useReduxState<Machine>(
    reduxStoreConfig.sparePartsCurrentMachine
);

  useEffect(() => {
    setRows(props.rows);
  }, [props.rows]);
  
  const handleToggleSwitch = () => {
    setValueSwitch(!valueSwitch);
  };

  useEffect(() => {
    const isDoc = (staff: any): staff is MachineDocument => true;
    const filteredDocs: MachineDocument[] = [];
    rows.forEach((d) => {
      if (isDoc(d)) {
        const doc: MachineDocument = d as MachineDocument;
        if (!valueSwitch) {
          if (lang === doc.lang || d.isCatalogPdf) filteredDocs.push(doc);
        } else filteredDocs.push(doc);
        doc.machineSerialNumber = currentMachine.serialNumber;
        doc.manufacturer = currentMachine.manufacturer;
      }
    });
    setDocs(filteredDocs);
  }, [valueSwitch, lang, rows]);

  return (
    <AppCustomTabPanel
      className={"technicalInfo"}
      value={props.tabsValue}
      index={0}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          margin: "10px 0",
          height: "35px !important",
        }}
      >
        <FormControlLabel
          sx={{ marginRight: 0, ".MuiFormControlLabel-label":{fontSize: 14,paddingTop: "3px",} }}
          control={
            <Switch checked={valueSwitch} onClick={handleToggleSwitch} />
          }
          label={t("spareparts.machineDocuments.allLanguages")}
        />
      </Box>
      <PartList
        items={docs}
        loading={props.loading}
        columns={[
          {
            name: "documentName",
            viewHeader: true,
            width: ColumnWidth.ShortTextWidth,
            align: ColumnAlign.Left,
            customComponent: FileDescrComponent,
          },
          {
            name: "fileName",
            viewHeader: true,
            customComponent: FileNameComponent,
            align: ColumnAlign.Left,
          },
        ]}
      />
    </AppCustomTabPanel>
  );
};

export default MachineDocumentList;
